import { HttpInterceptorFn } from '@angular/common/http';
import { SKIP_TOKEN } from '../http-context';

export const apiTokenInterceptor: HttpInterceptorFn = (request, next) => {
    if (request.context.get(SKIP_TOKEN)) {
        return next(request);
    }
    return next(request.clone({ withCredentials: true }));
};
